import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const testimonialImages = ['https://cdn.magicpatterns.com/uploads/84DkDo5e5XY7eLiTBAhbaA/TESTIMONIO_1.png', 'https://cdn.magicpatterns.com/uploads/fJt2pjWVq23fCmNDDSMYGa/TESTIMONIO_2.png', 'https://cdn.magicpatterns.com/uploads/rYvA9deRkpMQbEQCKwLXbU/TESTIMONIO_3.png', 'https://cdn.magicpatterns.com/uploads/3xeH34dP1JSuGc6t9nkBBS/TESTIMONIO_4.png', 'https://cdn.magicpatterns.com/uploads/segidNSHmcevVrTLR855Dv/TESTIMONIO_5.png', 'https://cdn.magicpatterns.com/uploads/7XPxeVvvA7kTqSkUFk5h8f/TESTIMONIO_6.png'];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % testimonialImages.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + testimonialImages.length) % testimonialImages.length);
  };
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-deco-bg overflow-hidden" data-id="element-231">
      <div className="max-w-7xl mx-auto" data-id="element-232">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-14" data-id="element-233">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-4 font-bold leading-tight" data-id="element-234">
            Mujeres que ya empezaron a crear sus flores eternas
          </h2>
          <p className="text-base sm:text-lg text-deco-taupe font-medium" data-id="element-235">
            Historias reales de alumnas que aprendieron desde cero con Deco
            Emprende.
          </p>
        </div>

        <div className="relative max-w-sm sm:max-w-md mx-auto" data-id="element-236">
          <div className="relative aspect-[4/5] w-full rounded-[2rem] overflow-hidden shadow-xl border-4 border-white bg-deco-card" data-id="element-237">
            <AnimatePresence mode="wait" data-id="element-238">
              <motion.img key={currentIndex} src={testimonialImages[currentIndex]} alt={`Testimonio ${currentIndex + 1}`} initial={{
              opacity: 0,
              x: 50
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -50
            }} transition={{
              duration: 0.4
            }} className="absolute inset-0 w-full h-full object-cover" data-id="element-239" />
            </AnimatePresence>
          </div>

          <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 sm:-translate-x-6 bg-white p-3 rounded-full shadow-lg border border-deco-warm text-deco-text hover:text-deco-terra transition-colors z-10" aria-label="Anterior testimonio" data-id="element-240">
            <ChevronLeft className="w-6 h-6" data-id="element-241" />
          </button>

          <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 sm:translate-x-6 bg-white p-3 rounded-full shadow-lg border border-deco-warm text-deco-text hover:text-deco-terra transition-colors z-10" aria-label="Siguiente testimonio" data-id="element-242">
            <ChevronRight className="w-6 h-6" data-id="element-243" />
          </button>

          <div className="flex justify-center gap-3 mt-8" data-id="element-244">
            {testimonialImages.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-deco-terra w-8 sm:w-10' : 'bg-deco-warm hover:bg-deco-terra/50'}`} aria-label={`Ir al testimonio ${idx + 1}`} data-id="element-245" />)}
          </div>
        </div>
      </div>
    </section>;
}